export default __webpack_public_path__ + "static/media/CU41 SALTO KS.3936c12e.jpg";